module.exports = __webpack_public_path__ + "static/media/avatar-D_Q.be43fe2e.png";